import { render, staticRenderFns } from "./GlobalIndicatorsKeyNumbers.vue?vue&type=template&id=5911a792&"
import script from "./GlobalIndicatorsKeyNumbers.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsKeyNumbers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports